import axios from 'axios';

import { authHeader } from '@H';

export default {
  getActiveCashierDuty: (date, staff) =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/bunk/cashier/cashier-duties/?is_end_duty=0&staff_id=${staff}`,
    }),
};
